import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const UserAddIcon = ({ color = '#9BA8AC', size = 24, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23 11H21V9C21 8.45 20.55 8 20 8C19.45 8 19 8.45 19 9V11H17C16.45 11 16 11.45 16 12C16 12.55 16.45 13 17 13H19V15C19 15.55 19.45 16 20 16C20.55 16 21 15.55 21 15V13H23C23.55 13 24 12.55 24 12C24 11.45 23.55 11 23 11Z"
      fill={color}
    />
    <path
      d="M16 19.375C16 16.411 12.411 14 8 14C3.588 14 0 16.411 0 19.375V23H16V19.375Z"
      fill={color}
    />
    <path
      d="M8 12C11.0376 12 13.5 9.53757 13.5 6.5C13.5 3.46243 11.0376 1 8 1C4.96243 1 2.5 3.46243 2.5 6.5C2.5 9.53757 4.96243 12 8 12Z"
      fill={color}
    />
  </svg>
);

UserAddIcon.propTypes = propTypes;

export default UserAddIcon;
